import React from 'react';
import QuestionsAnswered from '../services/QuestionsAnswered';

const faqs = [
  {
    q: 'How do I order?',
    a: `You can add your garments to your quote on our website and submit. A member of our team will then be in contact to discuss customising options and give you a final price. Alternatively, get in touch with us directly and we'll help you find the perfect garment, fit and design for your needs.`,
  },
  {
    q: 'Are your garments good quality?',
    a: 'Absolutely! We work with quality suppliers to ensure the highest quality garments.',
  },
  {
    q: 'Can I see what my garment will look like?',
    a: 'Yes. We will send over a digital mock up of your design before we go to print so you can double check it and make any changes if needed.',
  },
  {
    q: 'Which customisation processes do you offer?',
    a: 'We offer Direct to Film (DTF), embroidery and Heat Transfer Vinyl (HTV). Our team can help you choose a process for your garments and design.',
  },
  {
    q: 'Is there a minimum order?',
    a: `There's no minimum order, but we do give discounts for large orders - even if the personalisation is different. So if you're organising a group holiday, stag do or hen do, make sure you let us know roughly how many garments you want when you enquire!`,
  },
  {
    q: 'How much does it cost?',
    a: `Each order is unique and the price will vary depending on the quantity, design, individual personalisations and so on. We want to give you the best price so we don't include customisation prices on our website. Submit an enquiry and speak to us about your designs and we'll provide a full quote - with a discount on larger orders.`,
  },
  {
    q: 'When is payment due?',
    a: 'Payment is due before production begins.',
  },
  {
    q: 'How long do they take to print and deliver?',
    a: 'Production usually takes 5 to 10 working days, depending on design complexity and order size. We do have an express option available if you need your garments sooner, so please discuss this with us if required. Turnaround time starts from when your order has been placed and the design has been confirmed. For delivery outside the UK, please ask us for an estimated time scale.',
  },
];

const FAQ: React.FC = () => <QuestionsAnswered questions={faqs} />;

export default FAQ;
